import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderDocumentsConfigPartial } from '../order-documents.component';
export interface DialogPreviewData {
  orderId: number | string;
  userId: number | string;
  profileTypeId: number;
}
@Component({
    selector: 'app-dialog-preview-document',
    templateUrl: './dialog-preview-document.component.html',
    styleUrls: ['./dialog-preview-document.component.scss'],
    standalone: false
})
export class DialogPreviewDocumentComponent implements OnInit {
  orderDocumentsConfig: OrderDocumentsConfigPartial = {
    showOnlyOrderDocument: true,
    actionMode: 'readonly'
  }

  constructor(
    public dialogRef: MatDialogRef<DialogPreviewDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogPreviewData,
  ) { }

  ngOnInit(): void {
  }

}
